import apiRequest from '../config/api';

export interface PromoCode {
  id: number;
  code: string;
  discount_lt_type: 'PERCENTAGE' | 'NOMINAL' | null;
  discount_lt_value: number | null;
  discount_course_type: 'PERCENTAGE' | 'NOMINAL' | null;
  discount_course_value: number | null;
  discount_cbt_type: 'PERCENTAGE' | 'NOMINAL' | null;
  discount_cbt_value: number | null;
  is_active: boolean;
  max_uses: number | null;
  expires_at: string | null;
  uses_count?: number;
  created_at?: string;
  updated_at?: string;
}

export interface PromoCodeUsage {
  id: number;
  order_id: string;
  email: string;
  fullname: string;
  total: number;
  discount_amount: number;
  promo_code_str: string;
  status: string;
  created_at: string;
  course?: {
    id: number;
    title: string;
    type: string;
  };
  user?: {
    name: string;
    email: string;
  };
  promo_code?: PromoCode;
}

export const getPromoCodes = async (params: { page?: number; limit?: number; search?: string } = {}) => {
  await apiRequest.getCsrfCookie();
  const res = await apiRequest.get('/api/admin/promo-codes', { params });
  return res.data;
};

export const createPromoCode = async (data: Partial<PromoCode>) => {
  await apiRequest.getCsrfCookie();
  const res = await apiRequest.post('/api/admin/promo-codes', data);
  return res.data;
};

export const updatePromoCode = async (id: number, data: Partial<PromoCode>) => {
  await apiRequest.getCsrfCookie();
  const res = await apiRequest.put(`/api/admin/promo-codes/${id}`, data);
  return res.data;
};

export const togglePromoCodeStatus = async (id: number) => {
  await apiRequest.getCsrfCookie();
  const res = await apiRequest.post(`/api/admin/promo-codes/${id}/toggle-status`);
  return res.data;
};

export const deletePromoCode = async (id: number) => {
  await apiRequest.getCsrfCookie();
  const res = await apiRequest.delete(`/api/admin/promo-codes/${id}`);
  return res.data;
};

export const getPromoCodeUsages = async (params: { page?: number; limit?: number; search?: string } = {}) => {
  await apiRequest.getCsrfCookie();
  const res = await apiRequest.get('/api/admin/promo-codes/usages', { params });
  return res.data;
};

export const validatePromoCode = async (data: { code: string; course_id: number }) => {
  await apiRequest.getCsrfCookie();
  const res = await apiRequest.post('/api/promo-code/validate', data);
  return res.data;
};
